// What a combo box and a multi-select share: the text being typed, whether the list is open,
// which option the keyboard is on, and the options that text leaves.
//
// `typed` is null when nothing is being typed, which is not the same as an empty string - an
// input the user has emptied is a search for everything, and for a combo box a cleared value.

import { useState } from 'react';

import { narrow } from './optionSearch.js';

export default function useOptionList(options) {
  const [typed, setTyped] = useState(null);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const matches = narrow(options, typed ?? '');

  const type = (text) => {
    setTyped(text);
    setOpen(true);
    // The first match is one Enter away once something narrows the list.
    setActive(text ? 0 : -1);
  };

  const close = () => {
    setTyped(null);
    setOpen(false);
    setActive(-1);
  };

  // Enter picks the highlighted option; with none highlighted it is left to the form.
  const onKeyDown = (pick) => (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (matches.length === 0) return;
      const step = event.key === 'ArrowDown' ? 1 : -1;
      setOpen(true);
      setActive((index) => (open ? (index + step + matches.length) % matches.length : 0));
    } else if (event.key === 'Enter' && open && matches[active]) {
      event.preventDefault();
      pick(matches[active]);
    } else if (event.key === 'Escape' && open) {
      close();
    }
  };

  return { typed, open, active, matches, type, close, show: () => setOpen(true), setTyped, onKeyDown };
}
